<template>
    <div class="vc-panel">
        <!--菜单-->
        <div class="divmenu">
            <IconMenu @click="menuClick(menu)" class="menu-item" v-for="menu in listMenu" :key="menu" :selected="menu.key == menuKey"
                :svgname="menu.icon" :iconSize="menu.iconSize" :name="menu.name"></IconMenu>
        </div>
        <el-scrollbar class="vh-full">
            <div class="inrect">


                <component :is="menuKey"></component>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue';
import ShareDataView from './panel/ShareDataView.vue';
import WithdrawSetting from './panel/WithdrawSetting.vue';
import IconMenu from '@/components/IconMenu.vue';
export default {
    name: 'MySharePage',
    components: {
        SvgIcon,
        ShareDataView,
        WithdrawSetting,
        IconMenu
    },
    props: {

    },
    data() {
        return {
            menuKey: "ShareDataView",
            listMenu: [
                { name: "数据概览", key: "ShareDataView", icon: "ic_tongji2", iconSize: 16 },
                { name: "提现设置", key: "WithdrawSetting", icon: "ic_basic_setting", iconSize: 16 },
                // { name: "订单记录", key: "order", icon: "ic_order", iconSize: 17 },
                // { name: "提现记录", key: "withdraw", icon: "ic_tixian", iconSize: 15 }
            ],

        }
    },
    methods:{
        ///点击菜单
        menuClick:function(menu){
            this.menuKey = menu.key;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.divmenu {
    display: flex;
    padding-top: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid var(--ek-split-lineColor);
    margin-left: 20px;
    margin-right: 20px;
}

.menu-item {
    margin-right: 20px;
}

.menu-item.active {
    color: var(--ek-text-color1);
}

.inrect {
    padding-left: 30px;
    padding-top: 5px;
    padding-right: 30px;
}
</style>
